const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const resolveAssetUrl = (value?: string | null) => {
    if (!value) return '';
    if (value.startsWith('http://') || value.startsWith('https://')) return value;
    return `${API_URL}${value.startsWith('/') ? value : `/${value}`}`;
};

export const resolvePublicAssetUrl = (value?: string | null) => {
    if (!value) return '';
    if (value.startsWith('http://') || value.startsWith('https://')) return value;
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    return `${origin}${value.startsWith('/') ? value : `/${value}`}`;
};
